import { Status, UpdateStatus, CheckDevice } from "./Config/Status.js";
import CustomProperty from "./Modules/CustomProperty.js";
import Animation from "./Modules/Animation.js";
import ScrollTop from "./Modules/ScrollTop.js";
import * as Slider from "./Modules/Slider.js";

import Diagnosis from "./Modules/Diagnosis.js";
import Entry from "./Modules/Entry.js";

const page = Status.page.toLowerCase();

// init
CheckDevice();
CustomProperty();
// DrawerMenu.init();
// Modal.init();
// Cursor.init();
Slider.works();
Slider.company();
Slider.comment();
if(Status.isLocal) {
  // Debug();
}


// preload
window.addEventListener("DOMContentLoaded", () => UpdateStatus.load());


// load
window.addEventListener("load", () => UpdateStatus.load());
window.addEventListener("load", () => Animation.update());

// resize 
window.addEventListener("resize", () => UpdateStatus.resize());
window.addEventListener("resize", () => CheckDevice());
window.addEventListener("resize", () => CustomProperty());

// scroll 
window.addEventListener("scroll", () => UpdateStatus.scroll());
window.addEventListener("scroll", () => Animation.update());

// orientationchange
window.addEventListener("orientationchange", () => UpdateStatus.resize());


switch(page) {
  case "diagnosis":
    window.addEventListener("beforeunload", () => ScrollTop(false)); 
    window.addEventListener("DOMContentLoaded", () => Diagnosis());
  break;
  case "entry":
    window.addEventListener("beforeunload", () => ScrollTop(false)); 
    window.addEventListener("DOMContentLoaded", () => Entry());
  break;
  default:
  break;
}

